"use client";

import { createContext, useContext } from "react";

interface AccordionContextType {
  activeIndex: number;
  setActiveIndex: (index: number) => void;
  registerFirstItem: (id: number) => void;
}

export const AccordionContext = createContext<AccordionContextType | undefined>(
  undefined,
);

export const useAccordionContext = (): AccordionContextType => {
  const context = useContext(AccordionContext);
  if (!context) {
    throw new Error("AccordionItem must be used within Accordion");
  }
  return context;
};
